(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-brand-palette"] && !Shopify.designMode) return;
  try {
    
(() => {
  const copy = () => document.getElementById('kc-demo-copy')?.dataset || {};
  function selectAge(id, focus) {
    const card = document.querySelector(`[data-kc-age="${id}"]`);
    if (!card) return;
    document.querySelectorAll('[data-kc-age]').forEach(item => item.setAttribute('aria-current', String(item === card)));
    const status = document.querySelector('[data-kc-age-status]');
    const ages = { '3': '3–5', '6': '6–8', '9': '9+' };
    if (status) status.textContent = (copy().age || '').replace('{age}', ages[id]);
    if (focus) document.getElementById('kc-age-result')?.focus({preventScroll: true});
  }
  function readAgeHash() {
    const match = location.hash.match(/^#kc-age-(3|6|9)$/);
    if (match) selectAge(match[1], false);
  }
  document.addEventListener('click', event => {
    const age = event.target.closest('[data-kc-age]');
    if (age) selectAge(age.dataset.kcAge, true);
    const budget = event.target.closest('[data-kc-budget]');
    if (budget) {
      const section = budget.closest('.kc-gifts');
      const max = Number(budget.dataset.kcBudget);
      let shown = 0;
      section.querySelectorAll('[data-kc-budget]').forEach(b => b.setAttribute('aria-pressed', String(b === budget)));
      section.querySelectorAll('[data-kc-price]').forEach(card => {
        const matches = !max || Number(card.dataset.kcPrice) < max;
        card.hidden = !matches || shown >= 4;
        if (!card.hidden) shown++;
      });
      section.querySelector('[data-kc-budget-empty]').hidden = shown > 0;
      section.querySelector('[data-kc-budget-status]').textContent = shown ? (copy().count || '').replace('{count}', shown) : copy().empty;
    }
    const menuLink = event.target.closest('.menu-drawer a[href], .kc-nav a[href]');
    if (menuLink) {
      const url = new URL(menuLink.href);
      if (url.pathname === location.pathname && url.hash) {
        const drawer = document.getElementById('Details-menu-drawer-container');
        if (drawer?.open) drawer.querySelector(':scope > summary')?.click();
      }
      document.querySelectorAll('.kc-nav__group[open]').forEach(d => d.open = false);
    }
    if (!event.target.closest('.kc-nav')) document.querySelectorAll('.kc-nav__group[open]').forEach(d => d.open = false);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-kc-delivery]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    form.querySelector('[data-kc-delivery-result]').textContent = copy().delivery;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.kc-nav__group[open]').forEach(d => { d.open = false; d.querySelector('summary')?.focus(); });
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches('.kc-nav__group[open]')) document.querySelectorAll('.kc-nav__group[open]').forEach(d => { if (d !== event.target) d.open = false; });
  }, true);
  window.addEventListener('hashchange', readAgeHash);
  document.addEventListener('shopify:section:load', readAgeHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', readAgeHash); else readAgeHash();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kc-product-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kc-product-banners')) {
    customElements.define('kc-product-banners', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('.kc-banners__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = 0;
        this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.pauseButton = this.querySelector('[data-pause]');
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.select(this.index - 1, true), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.select(this.index + 1, true), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index, true), options));
        this.pauseButton?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.updatePause(); this.restart(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.restart(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.restart(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.restart(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.restart(); } }, options);
        this.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1), true); } }, options);
        this.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; this.touchY = event.changedTouches[0].clientY; }, { ...options, passive: true });
        this.addEventListener('touchend', event => { const dx = event.changedTouches[0].clientX - this.touchX; const dy = event.changedTouches[0].clientY - this.touchY; if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.select(this.index + (dx < 0 ? 1 : -1), true); }, { ...options, passive: true });
        document.addEventListener('visibilitychange', () => this.restart(), options);
        this.addEventListener('shopify:block:select', event => { const index = this.slides.indexOf(event.target); if (index >= 0) this.select(index, true); }, options);
        this.updatePause();
        this.restart();
      }
      select(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        if (manual) { this.userPaused = true; this.updatePause(); }
        this.restart();
      }
      updatePause() {
        if (!this.pauseButton) return;
        this.pauseButton.setAttribute('aria-label', this.userPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('span').textContent = this.userPaused ? '▶' : 'Ⅱ';
        this.querySelector('.kc-banners__slides').setAttribute('aria-live', this.userPaused ? 'polite' : 'off');
      }
      restart() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.userPaused && !this.hovered && !this.focused && !document.hidden) this.timer = setTimeout(() => this.select(this.index + 1), Number(this.dataset.delay) || 6000);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
